import { stylesheet } from 'typestyle';
import { Alert, Red80 } from '@traceair/tds';
import { OverdueUploadIcon } from '../../../../../images/components/OverdueUploadIcon';

const css = stylesheet({
  container: {
    marginTop: 8,
  },
});

interface Props {
  isScanOverdue: boolean;
  isPanoOverdue: boolean;
  isGcpOverdue: boolean;
}

export const MissionUploadOverdue = ({ isScanOverdue, isPanoOverdue, isGcpOverdue }: Props) => {
  const items: string[] = [];
  if (isScanOverdue) items.push('Scan');
  if (isPanoOverdue) items.push('panorama');
  if (isGcpOverdue) items.push('GCP');

  if (items.length === 0) return null;

  if (items[0] === 'panorama') {
    items[0] = 'Panorama';
  }

  const list =
    items.length === 1
      ? items[0]
      : items.length === 2
        ? `${items[0]} and ${items[1]}`
        : `${items.slice(0, -1).join(', ')} and ${items[items.length - 1]}`;

  const title = `${list} upload${items.length > 1 ? 's' : ''} overdue`;

  return (
    <Alert
      className={css.container}
      icon={<OverdueUploadIcon color={Red80} />}
      type="warning"
      title={title}
      description="Please upload the missing data or contact OPS team"
    />
  );
};
